var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { DivTag } from '../../Utils/AtomicTag';
import { defaultAnchorLinkProps } from './defaults';
import { qs, scrollTo } from '../../Utils/browser';
import { getOffset } from '../../Utils/browser';
var AnchorLink = /** @class */ (function (_super) {
    __extends(AnchorLink, _super);
    function AnchorLink(props) {
        var _this = _super.call(this, props) || this;
        _this.goTo = function (dom) {
            var changeScrollStatus = _this.props.changeScrollStatus;
            if (changeScrollStatus) {
                changeScrollStatus(true);
            }
            var activeFloorTop = dom ? getOffset(dom).offsetTop : 0;
            scrollTo(0, activeFloorTop, {}, function () {
                if (changeScrollStatus) {
                    changeScrollStatus(false);
                }
            });
        };
        return _this;
    }
    AnchorLink.prototype.getAnchorDom = function (selector) {
        return qs(selector);
    };
    AnchorLink.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, onClick = _a.onClick, href = _a.href, activeLink = _a.activeLink, activeClass = _a.activeClass, changeActiveLink = _a.changeActiveLink;
        var atomicBasicItem = [];
        var showActive = href === activeLink;
        return (React.createElement(DivTag, { atomics: atomicBasicItem, className: "" + (showActive && activeClass ? activeClass : className), onClick: function (event) {
                var dom = _this.getAnchorDom("#" + href);
                if (onClick) {
                    onClick(event, { title: dom, href: href });
                }
                if (changeActiveLink) {
                    changeActiveLink(href);
                }
                _this.goTo(dom);
            } }, this.props.children));
    };
    AnchorLink.defaultProps = defaultAnchorLinkProps;
    return AnchorLink;
}(React.PureComponent));
export default AnchorLink;
